"use client";

import { c as _c } from "react/compiler-runtime";
import { citiesInfo } from "@/info/cities";
import { usePathname } from "next/navigation";
interface UseCityResult {
  currentCity: string;
  isOnCityPage: boolean;
  isOnPreferencePage: boolean;
}

// List of supported cities - should match the ones in [city]/page.tsx
const SUPPORTED_CITIES = citiesInfo.map(a => a.code);
const DEFAULT_CITY = "bengaluru";

/**
 * Hook to get current city context from URL pathname
 * Returns the current city, whether user is on a city page, and whether on preference page
 */
export function useCurrentCity() {
  const $ = _c(7);
  const pathname = usePathname();
  const isOnPreferencePage = pathname === "/preference";
  let currentCity = DEFAULT_CITY;
  let isOnCityPage = false;
  if (pathname?.startsWith("/")) {
    if ($[0] !== pathname) {
      const segments = pathname.split("/").filter(Boolean) || [];
      if (segments.length > 0) {
        const firstSegment = segments[0].toLowerCase();
        if (SUPPORTED_CITIES.includes(firstSegment)) {
          currentCity = firstSegment;
          isOnCityPage = true;
        }
      }
      $[0] = pathname;
      $[1] = currentCity;
      $[2] = isOnCityPage;
    } else {
      currentCity = $[1];
      isOnCityPage = $[2];
    }
  }
  let t0;
  if ($[3] !== currentCity || $[4] !== isOnCityPage || $[5] !== isOnPreferencePage) {
    t0 = {
      currentCity,
      isOnCityPage,
      isOnPreferencePage
    };
    $[3] = currentCity;
    $[4] = isOnCityPage;
    $[5] = isOnPreferencePage;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  return t0;
}

/**
 * Simple hook that just returns the current city string
 * Useful when you only need the city name for navigation
 */
export function useCurrentCityName() {
  const {
    currentCity
  } = useCurrentCity();
  return currentCity;
}